import { ErrorHandler, Injectable, inject } from '@angular/core';
import { PostHogService } from './posthog.service';

/**
 * Routes uncaught Angular errors to PostHog error tracking.
 *
 * Deliberately still calls console.error afterwards: replacing Angular's default
 * ErrorHandler silently swallows the console output developers rely on, which is a
 * worse debugging experience than having no error tracking at all.
 */
@Injectable()
export class PostHogErrorHandler implements ErrorHandler {
    private posthog = inject(PostHogService);

    handleError(error: any): void {
        try {
            this.posthog.captureException(error, { source: 'angular_error_handler' });
        } catch {
            // Never let the error handler throw — that produces an unbreakable loop.
        }

        // Preserve Angular's default behaviour.
        console.error(error);
    }
}
